import { render, staticRenderFns } from "./TaskPointItem.vue?vue&type=template&id=875a9ace&scoped=true&"
import script from "./TaskPointItem.vue?vue&type=script&lang=js&"
export * from "./TaskPointItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskPointItem.vue?vue&type=style&index=0&id=875a9ace&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875a9ace",
  null
  
)

export default component.exports